var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorPayment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150.795,
    height: 97.795,
    viewBox: "0 0 150.795 97.795",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14424",
    "data-name": "Group 14424",
    transform: "translate(-9772.5 -7530.705)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "no_payments-13",
    "data-name": "no payments-13",
    transform: "translate(9776 7533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46412",
    d: "M88.2,135.558a21.156,21.156,0,0,1-8.836-1.64,19.077,19.077,0,0,1-6.558-4.463,20.117,20.117,0,0,1-4.1-6.832,25.838,25.838,0,0,1-1.366-8.745,25.047,25.047,0,0,1,2.368-11.2,18.54,18.54,0,0,1,6.832-7.651A20.21,20.21,0,0,1,87.285,92.2a27.019,27.019,0,0,1,3.826.273c1.275.182,2.459.364,3.644.638a26.621,26.621,0,0,1,3.188.911,27.345,27.345,0,0,1,2.642,1l-.547,6.285a25.519,25.519,0,0,0-8.38-2.915,24.53,24.53,0,0,0-3.644-.273,12.821,12.821,0,0,0-7.1,1.913,12.293,12.293,0,0,0-4.737,5.374,20.622,20.622,0,0,0-1.731,8.38,22.437,22.437,0,0,0,.82,6.1,16.027,16.027,0,0,0,2.642,5.1,12.835,12.835,0,0,0,4.463,3.461,15.478,15.478,0,0,0,6.467,1.275,23.331,23.331,0,0,0,3.552-.273,28.678,28.678,0,0,0,3.826-.82,17.743,17.743,0,0,0,3.735-1.822l.455,6.194a17.713,17.713,0,0,1-2.733,1.184,30.732,30.732,0,0,1-3.1.82c-1.093.182-2.186.364-3.279.455C90.291,135.467,89.289,135.558,88.2,135.558ZM62.6,120.619v-4.19H92.659v4.19Zm0-8.836v-4.19H94.481v4.19Z",
    transform: "translate(-42.925 -65.601)",
    fill: "#0f3a4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46416",
    "data-name": "Path 46416",
    d: "M178.545,99.517v47.457a8.514,8.514,0,0,1-8.471,8.471H49.471A8.514,8.514,0,0,1,41,146.974v-70.5A8.514,8.514,0,0,1,49.471,68h96.554",
    transform: "translate(-41 -63.446)",
    fill: "none",
    stroke: "#0f3a4a",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    y1: 29,
    x2: 29,
    transform: "translate(116 0)",
    fill: "none",
    stroke: "#ff4b3c",
    strokeWidth: 6.492
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    x2: 29,
    y2: 29,
    transform: "translate(116 0)",
    fill: "none",
    stroke: "#ff4b3c",
    strokeWidth: 6.492
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    x2: 43.814,
    transform: "translate(76.515 62.851)",
    fill: "none",
    stroke: "#e1e289",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    x2: 26,
    transform: "translate(77 44)",
    fill: "none",
    stroke: "#e1e289",
    strokeWidth: 10
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorPayment);
export default __webpack_public_path__ + "static/media/error-payment.042b8f28ee34d4b25b45926273cd4aa9.svg";
export { ForwardRef as ReactComponent };